<div class="login-box">
  <div class="login-logo">
    <a routerLink="/"
      ><b>{{ appName }}</b></a
    >
  </div>
  <!-- /.login-logo -->
  <div class="card">
    <div class="card-body login-card-body">
      <p class="login-box-msg">Give validation code to start your session</p>
      <form [formGroup]="tfaForm" (ngSubmit)="LoginByTFA()" class="mb-3">
        <div class="input-group mb-3">
          <input
            type="text"
            [ngClass]="{
              'is-invalid': tfaForm.get('TFACode').errors && tfaForm.get('TFACode').touched
            }"
            class="form-control"
            formControlName="TFACode"
            placeholder="Code"
          />
          <div class="input-group-append">
            <div class="input-group-text">
              <span class="fas fa-qrcode"></span>
            </div>
          </div>
          <div class="invalid-feedback" *ngIf="tfaForm.get('TFACode').hasError('required') && tfaForm.get('TFACode').touched">
            Please provide validation code
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <button type="submit" class="btn btn-primary btn-block">
              Submit
            </button>
          </div>
        </div>
      </form>
    </div>
    <!-- /.login-card-body -->
  </div>
  <div class="lockscreen-footer text-center"><span [innerHTML]="copyright"></span></div>
</div>
